import React, {Fragment, useEffect} from "react";
import { Outlet, Link } from "react-router-dom";
import { getAction } from "../util/helper";
// redux
import { useSelector, useDispatch } from 'react-redux';
import codeReducer from "../redux/reducers/codeReducer";
import { setCodes } from "../redux/actions/codeAction";
import codeGroupReducer from "../redux/reducers/codeGroupReducer";
import { setCodeGroups } from "../redux/actions/codeGroupAction";
import WebService from "../util/webService";
import { Navigate } from "react-router-dom";
import { setSchools } from '../redux/actions/schoolAction';
import { useNavigate } from "react-router-dom";

const fetchSchools = async() => {

}
const onLoad = async dispatch => {
  console.log('RootPage onLoad...')
  // let url = '/codeGroup'
  // let action = getAction(url, {})
  // let resp = await WebService.get(action)
  // if(resp.repCode === 'ack') {
  //   const repMessage = JSON.parse(resp.repMessage)
  //   const records  = JSON.parse(repMessage.records)
  //   dispatch(setCodeGroups(records))
  // }

  // url = '/code'
  // action = getAction(url, {})
  // resp = await WebService.get(action)
  // if(resp.repCode === 'ack') {
  //   const repMessage = JSON.parse(resp.repMessage)
  //   const records  = JSON.parse(repMessage.records)
  //   dispatch(setCodes(records))
  // }

  // url = '/school'
  // resp = await WebService.get(url)
  // if(resp.repCode === 'ack') {
  //   const repMessage = JSON.parse(resp.repMessage)
  //   const records  = JSON.parse(repMessage.records)
  //   records.forEach(r => {
  //     r.label = `${r.name}(${r.newZipCode}, ${r.newAddr1})`
  //   })
  //   dispatch(setSchools(records))
  // }
}

const RootPage = () => {
  // redux
  const dispatch = useDispatch()
  const account = useSelector(state => state.accountReducer)
  const navigate = useNavigate()

  useEffect(() => {
    onLoad(dispatch)
    if(account.hasOwnProperty('user')) {
      navigate('/welcome')
    }
    else {
      navigate('/login')
    }
  }, [])

  return (
    <Fragment></Fragment>
  )
};

export default RootPage;
